<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <!--<Wxts :wxtsList="wxtsList" />-->
    </div>

    <el-form ref="form" :model="form" :label-width="labelWidth">
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />

      <el-form-item label="出车费用表设置" prop="cost" :label-width="labelWidth" class="item">
        <el-checkbox-group class="list" v-model="checkList" @change="onCheckChange">
          <el-checkbox class="item" v-for="(c, i) in checkOptions" :key="'itemm' + i" :label="c.value">
            {{ c.label }}
          </el-checkbox>
        </el-checkbox-group>
        <span class="tips">勾选的类型才会显示在出车费用表中</span>
      </el-form-item>

      <el-form-item label="是否计入固定费用" prop="cost" :label-width="labelWidth" class="item">
        <el-checkbox-group class="list" v-model="checkList2" @change="onCheckChange2">
          <el-checkbox class="item" v-for="(c, i) in checkOptions2" :key="'itemm' + i" :label="c.value">
            {{ c.label }}
          </el-checkbox>
        </el-checkbox-group>
        <span class="tips">勾选的类型将计入固定费支出表中</span>
      </el-form-item>

      <el-form-item label="是否加入车辆年检" prop="cost" :label-width="labelWidth" class="item">
        <el-checkbox-group class="list" v-model="checkList3" @change="onCheckChange3">
          <el-checkbox class="item" v-for="(c, i) in checkOptions3" :disabled="c.disabled" :key="'itemm' + i"
            :label="c.value">
            {{ c.label }}
          </el-checkbox>
        </el-checkbox-group>
        <span class="tips">勾选的类型将加入车辆年检列表中</span>
      </el-form-item>
    </el-form>

    <div class="btns">
      <el-button type="primary" @click="onSubmit">保 存</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
//import Wxts from '../../../components/Wxts.vue';
export default {
  name: "FinanceBaseSalary",
  //components: { Wxts },
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'system',
      // wxtsList: [
      //   {
      //     name:'基本工资是设置统一工资，如果工资有差别，可在',
      //     path: '/staff/driver',
      //     pathName: '【人员管理】',
      //     tailName: '对应岗位处做个别修改。',
      //   },
      //   {
      //     name:'提成初始毛利润是超过设置毛利润后可享受提成起始点，提成比例是对超出初始毛利润部分的提成比例。'
      //   },
      //   {
      //     name:'例如：某车净利润为25000元，司机提成初始毛利润为20000元，提成比例为20%，那么司机的应得提成奖金为1000元。算式为（25000-20000）×20%=1000元。'
      //   },
      // ],
      breadcrumb: [
        { name: "系统设置" },
        { name: "基础设置" },
      ],
      formCtrl: [
        {
          label: "是否允许连续派单",
          keyName: "is_continued",
          type: "radio",
          options: [
            { label: '是', value: 1 },
            { label: '否', value: 0 },
          ],
        },
      ],
      checkList: [],
      checkList2: [],
      checkList3: ['1'],
      checkOptions: [
        { label: '车辆加油', value: '1' },
        { label: '出车费用', value: '2' },
        { label: '里程登记', value: '3' },
      ],
      checkOptions2: [
        { label: '车辆年检', value: '1' },
        { label: '违章罚款', value: '2' },
      ],
      checkOptions3: [
        { label: '车头', value: '1', disabled: true },
        { label: '挂车', value: '2' },
      ],
    };
  },
  methods: {
    onCheckChange(v) {
      console.log(v)
      if (v && v.length) {
        const arr = [...v]
        this.form.cost = arr.join(',')
      } else {
        this.form.cost = null
      }
      console.log(this.checkList)
      console.log(this.form)
    },
    onCheckChange2(v) {
      console.log(v)
      if (v && v.length) {
        const arr = [...v]
        this.form.fixedpay = arr.join(',')
      } else {
        this.form.fixedpay = null
      }
      // console.log(this.checkList2)
      // console.log(this.form)
    },
    onCheckChange3(v) {
      console.log(v)
      if (v && v.length) {
        const arr = [...v]
        this.form.inspection = arr.join(',')
      } else {
        this.form.inspection = '1'
      }
      // console.log(this.checkList3)
      // console.log(this.form)
    },
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/index`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          this.detail = data
          this.formCtrl.map(v => {
            const key = v.keyName
            this.form[key] = this.detail[key];
          })
          this.checkList = []
          if (data.cost && data.cost.length) {
            data.cost.map(v => {
              if (v) {
                this.checkList.push(v)
              }
            })
            this.$nextTick(() => {
              if (this.checkList.length) {
                this.form.cost = this.checkList.join(',')
              }
            })
          }
          if (data.fixedpay && data.fixedpay.length) {
            data.fixedpay.map(v => {
              if (v) {
                this.checkList2.push(v)
              }
            })
            this.$nextTick(() => {
              if (this.checkList2.length) {
                this.form.fixedpay = this.checkList2.join(',')
              }
            })
          }
          if (data.inspection && data.inspection.length) {
            data.inspection.map(v => {
              if (v && v != 1) {
                this.checkList3.push(v)
              }
            })
            this.$nextTick(() => {
              if (this.checkList3.length) {
                this.form.inspection = this.checkList3.join(',')
              }
            })
          }
          this.$forceUpdate()
          // console.log({ ...this.detail })
          // console.log({ ...this.form })
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSubmit() {
      console.log({ ...this.form });
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.submitReq).catch(() => { });
    },
    submitReq() {
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        // userid: this.user.id,
      }
      const object = this.form
      if (!this.form.inspection.includes(1)) {
        this.form.inspection = '1'
      }
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getData()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getData()
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .tips {
      display: inline-block;
      width: auto;
      min-width: 220px;
      height: 100%;
      font-size: 12px;
    }

    .el-input {
      width: 200px;
    }
  }

  // .el-textarea {
  //   width: 200px;
  // }

  .el-checkbox.is-disabled.is-checked {
    .el-checkbox__inner {
      background-color: #409EFF;
      border-color: #409EFF;
    }

    .el-checkbox__label {
      color: #606266;
    }
  }

  .item {
    .list {
      display: inline-block;
      min-width: 350px;
    }

    span.tips {
      display: inline-block;
    }
  }
}

.btns {
  margin: 40px 0 60px 180px;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;

  /deep/ .wxts {
    .b {
      width: 400px;
    }
  }
}
</style>
